import {observer} from "mobx-react";
import React from "react";
import {SliderTimeRange} from "@dropDesk/presentation/components/slider_time_range";
import {
    ContainerHourAndTimeRange,
    ContainerInputRange,
    ContainerSecondTimeRange,
    ContentHourAndTimeRange,
    ContentInputRange,
    ContentSecondHourAndTimeRange,
    ContentSecondTimeRange,
    TextAs,
    TextSecondHour
} from "@dropDesk/presentation/pages/company_configurations/ui/business_hour_operator/hours/saturday/styled";
import CheckBoxWithLabel from "@dropDesk/presentation/components/check_box/check_box_with_label";
import {
    CompanyConfigurationEntity
} from "@dropDesk/domain/entities/company_configurations/company_configuration.entity";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {
    useValidatorHours
} from "@dropDesk/presentation/pages/company_configurations/ui/business_hour_operator/hours/validator";
import {TextError} from "@dropDesk/presentation/pages/company_configurations/ui/business_hour_operator/styled";


const Saturday = observer(
    ({
         loading,
         onUpdate,
         companyConfiguration
     }: {
        loading: boolean,
        onUpdate: (companyConfiguration: CompanyConfigurationEntity) => void,
        companyConfiguration: CompanyConfigurationEntity
    }) => {
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        const handleAllChanges = (event: {
            target: { name: string; value: any; checked?: any; type: string }
        }, initialHour?: string | null, endHour?: string | null, isSecondDate: boolean = false) => {

            let _configuration = companyConfiguration.copyWith({

                businessOperationHours: companyConfiguration.businessOperationHours.copyWith({

                    saturday: companyConfiguration.businessOperationHours.saturday.copyWith({
                        [event.target.name]:
                            (event.target.type === "checkbox" || event.target.type === "switch") ?
                                event.target.checked : event.target.value
                    })
                })
            });

            if (initialHour && endHour) {
                _configuration = setDate(initialHour, endHour, isSecondDate);
            }

            onUpdate(_configuration);
        };

        const setDate = (initialDate: string, endDate: string, isSecondDate: boolean): CompanyConfigurationEntity => {
            return companyConfiguration.copyWith({

                businessOperationHours: companyConfiguration.businessOperationHours.copyWith({

                    saturday: companyConfiguration.businessOperationHours.saturday.copyWith({
                        initialFirstHour: isSecondDate ? companyConfiguration.businessOperationHours.saturday.initialFirstHour : initialDate,
                        endFirstHour: isSecondDate ? companyConfiguration.businessOperationHours.saturday.endFirstHour : endDate,
                        initialSecondHour: isSecondDate ? initialDate : companyConfiguration.businessOperationHours.saturday.initialSecondHour,
                        endSecondHour: isSecondDate ? endDate : companyConfiguration.businessOperationHours.saturday.endSecondHour,
                    })
                })
            })

        }

        const {errorSaturday} = useValidatorHours(companyConfiguration.businessOperationHours);
        return (
            <div>
                <ContainerHourAndTimeRange>
                    <ContentHourAndTimeRange>
                        <CheckBoxWithLabel
                            label={
                                companyConfiguration.businessOperationHours.saturday.open ?
                                    `Sábado (${companyConfiguration.businessOperationHours.saturday.initialFirstHour ?? '09:00'} - ${companyConfiguration.businessOperationHours.saturday.endFirstHour ?? '18:00'})`
                                    :
                                    `Sábado (Fechado o dia inteiro)`}
                            checked={companyConfiguration.businessOperationHours.saturday.open ?? false}
                            marginLeft={10}
                            disabled={loading}
                            onChange={(event) => {
                                handleAllChanges({
                                    target:
                                        {
                                            name: 'open',
                                            value: event.target.value,
                                            checked: event.target.checked,
                                            type: 'switch'
                                        }
                                });

                            }}
                        />
                    </ContentHourAndTimeRange>
                    {companyConfiguration.businessOperationHours.saturday.open && <ContainerInputRange>
                        <ContentInputRange>
                            < SliderTimeRange
                                disabled={loading}
                                value={{
                                    start: companyConfiguration.businessOperationHours.saturday.initialFirstHour ?? '09:00',
                                    end: companyConfiguration.businessOperationHours.saturday.endFirstHour ?? '18:00'
                                }}
                                onChange={({start, end}) => {
                                    handleAllChanges({
                                        target:
                                            {
                                                name: 'date',
                                                value: start,
                                                checked: false,
                                                type: 'input'
                                            }
                                    }, start, end, false);
                                }}
                            />
                        </ContentInputRange>
                        {companyConfiguration.businessOperationHours.usesTwoOperationHours &&
                            <ContainerSecondTimeRange>
                                <TextAs color={colors.text}>até as</TextAs>
                                <ContentSecondTimeRange style={{marginTop: -40}}>
                                    <ContentSecondHourAndTimeRange>
                                        <TextSecondHour
                                            color={colors.text}>({companyConfiguration.businessOperationHours.saturday.initialSecondHour} - {companyConfiguration.businessOperationHours.saturday.endSecondHour})
                                            {!!errorSaturday && <TextError
                                                color={colors.textError}>{errorSaturday}</TextError>}</TextSecondHour>
                                    </ContentSecondHourAndTimeRange>
                                    <ContentInputRange>
                                        < SliderTimeRange
                                            disabled={loading}
                                            value={{
                                                start: companyConfiguration.businessOperationHours.saturday.initialSecondHour ?? '09:00',
                                                end: companyConfiguration.businessOperationHours.saturday.endSecondHour ?? '18:00'
                                            }}
                                            onChange={({start, end}) => {

                                                handleAllChanges({
                                                    target:
                                                        {
                                                            name: 'date',
                                                            value: start,
                                                            checked: false,
                                                            type: 'input'
                                                        }
                                                }, start, end, true);
                                            }}
                                        />
                                    </ContentInputRange>
                                </ContentSecondTimeRange>
                            </ContainerSecondTimeRange>}
                    </ContainerInputRange>
                    }
                </ContainerHourAndTimeRange>
            </div>

        )
    })
export default Saturday;
